import React, { useMemo, useState } from 'react';
import {
  PreparedListItem,
  usePreparedPoolsRows
} from '@app/hooks/pools/usePreparedPoolsRows';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';
import { Box, VStack, Text } from '@chakra-ui/react';
import { VaultTags } from '@app/screens/pools/components/VaultTags';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { PoolDetails } from '@app/screens/liquidity/LiquidityWizard/components/SelectTokensStep/components/PoolDetails';
import { VaultDetails } from '@app/screens/liquidity/LiquidityWizard/components/SelectTokensStep/components/VaultDetails';

const vaultsOptions = [
  { title: 'All', value: 'all' },
  { title: 'Vaults', value: 'vaults' },
  { title: 'V4', value: 'v4' }
  // { title: 'V2', value: 'v2' }
];

function arePairsEqual(a: string, b: string, c: string, d: string): boolean {
  return (
    (a.toLowerCase() === c.toLowerCase() &&
      b.toLowerCase() === d.toLowerCase()) ||
    (a.toLowerCase() === d.toLowerCase() && b.toLowerCase() === c.toLowerCase())
  );
}

export const PoolsList = () => {
  const { preparedList } = usePreparedPoolsRows('', true);
  const [filter, setFilter] = useState('all');
  const { currencyA, currencyB } = useLiquidityWizardState();

  const filteredPools = useMemo(() => {
    if (!currencyA || !currencyB) {
      return null;
    }

    const vaults: PreparedListItem[] = [];
    const v4: PreparedListItem[] = [];
    const v2: PreparedListItem[] = [];

    preparedList
      .filter(item => {
        switch (item.view) {
          case 'v4': {
            return arePairsEqual(
              currencyA.wrapped.address,
              currencyB.wrapped.address,
              item.data.pool.token0.id,
              item.data.pool.token1.id
            );
          }
          case 'vaults':
          case 'v2': {
            return arePairsEqual(
              currencyA.wrapped.address,
              currencyB.wrapped.address,
              item.data.token0.id,
              item.data.token1.id
            );
          }
          default: {
            return false;
          }
        }
      })
      .forEach(item => {
        switch (item.view) {
          case 'vaults': {
            vaults.push(item);
            break;
          }
          case 'v4': {
            v4.push(item);
            break;
          }
          case 'v2': {
            v2.push(item);
            break;
          }
          default: {
            break;
          }
        }
      });

    return {
      vaults: filter === 'vaults' || filter === 'all' ? vaults : [],
      v4: filter === 'v4' || filter === 'all' ? v4 : [],
      v2: []
    };
  }, [currencyA, currencyB, filter, preparedList]);

  return (
    <Box w="100%">
      <AddLiquiditySectionTitle label="Select pool" isCompleted />
      <Box my={4}>
        <VaultTags
          items={vaultsOptions}
          onSelect={val => setFilter(val)}
          selected={filter}
        />
      </Box>
      {!!filteredPools?.vaults?.length && (
        <VStack width="100%" gap={4} alignItems="flex-start" mt={4}>
          <Text fontSize={16}>Vaults</Text>
          {filteredPools.vaults.map(item => {
            const { marketMaker } = item.data;

            return (
              <VaultDetails
                key={item.data.id}
                item={item.data}
                marketMakerCampaign={marketMaker}
              />
            );
          })}
        </VStack>
      )}
      {!!filteredPools?.v4?.length && (
        <VStack width="100%" gap={4} alignItems="flex-start" mt={4}>
          <Text fontSize={16}>V4</Text>
          {filteredPools.v4.map(item => {
            const { pool, badgesConfig, apr, marketMaker } = item.data;

            return (
              <PoolDetails
                badges={badgesConfig}
                key={pool.id}
                item={pool}
                apr={apr}
                marketMakerCampaign={marketMaker}
              />
            );
          })}
        </VStack>
      )}
      {/*{!!filteredPools?.v2?.length && (*/}
      {/*  <VStack width="100%" gap={4} alignItems="flex-start" mt={4}>*/}
      {/*    <Text fontSize={16}>V2</Text>*/}
      {/*    {filteredPools.v2.map(item => {*/}
      {/*      const { pairsDayData, ethPrice, id } = item.data;*/}
      {/*      const dayData = pairsDayData?.filter(*/}
      {/*        (p: { pairAddress: any }) => p.pairAddress === id*/}
      {/*      );*/}

      {/*      return (*/}
      {/*        <PoolDetailsV2*/}
      {/*          key={id}*/}
      {/*          item={item.data}*/}
      {/*          ethPrice={ethPrice}*/}
      {/*          dayData={dayData}*/}
      {/*        />*/}
      {/*      );*/}
      {/*    })}*/}
      {/*  </VStack>*/}
      {/*)}*/}
    </Box>
  );
};
